import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FieldsService {

  constructor(private http: HttpClient) { }

  getBrandList(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Brand`);
  }

  addBrandList(c) {
    return this.http.post<any>(`${environment.inventoryURl}Brand`, c)
      .toPromise()
      .then(res => res);
  }

  updateBrandList(c) {
    return this.http.put<any>(`${environment.inventoryURl}Brand`, c)
      .toPromise()
      .then(res => res);
  }

  deleteBrandList(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Brand/${id}`)
      .toPromise()
      .then(res => res);
  }

  getInventoryGroupList() {
    return this.http.get<any>(`${environment.coreUrl}Group`);
  }

  getWarrantyList(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${id}`);
  }

  addWarrantyList(c) {
    return this.http.post<any>(`${environment.coreUrl}Type`, c)
      .toPromise()
      .then(res => res);
  }

  updateWarrantyList(c) {
    return this.http.put<any>(`${environment.coreUrl}Type`, c)
      .toPromise()
      .then(res => res);
  }

  checkProductAvailability(id,type) {
    let params = new HttpParams();
    params =  (type=='Brand' ? params.append('brandId', id): params);
    params =  (type=='Warranty' ? params.append('typeId', id): params);
    params =  (type=='color' ? params.append('colorTypeId', id): params);
    params =  (type=='variant' ? params.append('variantId', id): params);
    return this.http.get<any>(`${environment.inventoryURl}Product/CheckFieldProductAssociation`, {params})
  }

  deleteWarrantyList(id) {
    return this.http.delete<any>(`${environment.coreUrl}Type/${id}`)
      .toPromise()
      .then(res => res);
  }

  getAllItemColor(groupId): Observable<any> {
    return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`);
  }

  addItemColor(data) {
    return this.http.post<any>(`${environment.coreUrl}Type`, data);
  }

  updateItemColor(data) {
    return this.http.put<any>(`${environment.coreUrl}Type`, data);
  }

  deleteItemColor(id) {
    return this.http.delete<any>(`${environment.coreUrl}Type/${id}`)
    .toPromise()
    .then(res => res);
  }

  getInventoryVariantGroups(id): Observable<any> {
    return this.http.get<any>(`${environment.coreUrl}Group?parentGroupId=${id}`);
  }

  addInventoryVariantGroups(value) {
    return this.http.post<any>(`${environment.coreUrl}Group`, value);
  }

  updateInventoryVariantGroups(value) {
    return this.http.put<any>(`${environment.coreUrl}Group`, value);
  }

  deleteVariant(id) {
    return this.http.delete<any>(`${environment.coreUrl}Group/${id}`)
      .toPromise()
      .then(res => res);
  }
}
